import React, { useMemo } from "react";

const PawIcon = ({ className, ...rest }) => (
  <svg viewBox="0 0 64 64" fill="currentColor" className={className} {...rest}>
    <ellipse cx="20" cy="20" rx="7.5" ry="10" transform="rotate(-18 20 20)" />
    <ellipse cx="34" cy="14" rx="7" ry="10.5" transform="rotate(-6 34 14)" />
    <ellipse cx="47" cy="20" rx="7" ry="9.5" transform="rotate(16 47 20)" />
    <ellipse cx="55" cy="34" rx="6.5" ry="8.5" transform="rotate(28 55 34)" />
    <path d="M34 28c9 0 17 7.4 17 15.4 0 6.6-5 10.6-11.4 10.6-3 0-4.4-1.2-7-1.2s-4 1.2-7 1.2C19.2 54 14 50 14 43.4 14 35.4 25 28 34 28Z" />
  </svg>
);

/**
 * Patinhas flutuando no fundo. Posições sorteadas uma única vez por montagem
 * para o campo nunca ficar simétrico demais — parece orgânico.
 */
const PawField = ({ count = 12, tone = "rgba(15,31,61,.05)" }) => {
  const paws = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: `${Math.random() * 96}%`,
        top: `${Math.random() * 92}%`,
        size: 18 + Math.random() * 46,
        rotate: Math.random() * 360,
        duration: 6 + Math.random() * 7,
        delay: -Math.random() * 8,
        opacity: 0.35 + Math.random() * 0.65,
      })),
    [count]
  );

  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
      {paws.map((paw) => (
        // Wrapper cuida de posição e rotação; o ícone cuida da flutuação —
        // separados para os dois `transform` não brigarem entre si.
        <span
          key={paw.id}
          className="absolute block"
          style={{
            left: paw.left,
            top: paw.top,
            width: paw.size,
            height: paw.size,
            transform: `rotate(${paw.rotate}deg)`,
            opacity: paw.opacity,
          }}
        >
          <PawIcon
            className="h-full w-full animate-float"
            style={{
              color: tone,
              animationDuration: `${paw.duration}s`,
              animationDelay: `${paw.delay}s`,
            }}
          />
        </span>
      ))}
    </div>
  );
};

export { PawIcon };
export default PawField;
